import React from 'react';
import Navbar from './Navbar';

export default function PrivacyPage() {
  return (
    <>
      <Navbar />
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '60px 24px' }}>
        <div className="badge badge-accent" style={{ marginBottom: 16 }}>Legal</div>
        <h1 style={{ fontFamily: 'var(--display)', fontSize: 'clamp(28px,5vw,48px)', fontWeight: 800, letterSpacing: '-0.03em', marginBottom: 8 }}>Privacy Policy</h1>
        <p style={{ color: 'var(--muted)', fontSize: 14, marginBottom: 40, fontFamily: 'var(--mono)' }}>Effective date: April 10, 2026 · TrustTech Mobile</p>

        {[
          {
            title: '1. Introduction',
            body: 'SafeSnap is developed and operated by TrustTech Mobile. This Privacy Policy explains what information we collect, how we use it, and how we protect it. By using SafeSnap, you agree to this policy.'
          },
          {
            title: '2. Information We Collect',
            body: 'When you take a verified photo, we record: GPS coordinates, device manufacturer and model, timestamp (UTC), a SHA-256 cryptographic hash of your photo, use case selection, and a unique Proof ID. We do NOT collect your name, email, or upload your photos to our servers. Photos stay on your device.'
          },
          {
            title: '3. How We Use Your Information',
            body: 'Proof records (Proof ID, hash, GPS, timestamp, device, use case) are stored in Google Firebase to enable tamper verification. No data is used for advertising, marketing, or any commercial purpose other than providing the SafeSnap verification service.'
          },
          {
            title: '4. Data Storage and Security',
            body: 'Proof records are stored securely on Google Firebase servers, operated by Google LLC and compliant with international data protection standards. Data may be stored in the United States or other countries where Google operates. We implement reasonable security measures, however no electronic storage method is 100% secure.'
          },
          {
            title: '5. Data Sharing',
            body: 'We do not sell, trade or rent your data. Your proof record is accessible to anyone with your Proof ID — this is by design to allow verification. You are responsible for sharing your Proof ID only with trusted parties. We may disclose data if required by law.'
          },
          {
            title: '6. Data Retention and Deletion',
            body: 'Proof records are stored indefinitely to allow long-term verification. To request deletion, contact safesnap.app@gmail.com with your Proof ID(s). We will delete records within 30 days.'
          },
          {
            title: '7. Third-Party Services',
            body: 'SafeSnap uses Google Firebase for cloud storage of proof records, and Google Play Billing for subscription payments. Both are subject to Google\'s Privacy Policy at policies.google.com/privacy.'
          },
          {
            title: '8. Your Rights',
            body: 'Depending on your location, you may have the right to access, correct or delete your data. To exercise these rights, contact safesnap.app@gmail.com.'
          },
          {
            title: '9. Children\'s Privacy',
            body: 'SafeSnap is not intended for children under 13. We do not knowingly collect information from children. Contact us if you believe a child has used the app.'
          },
          {
            title: '10. Changes',
            body: 'We may update this policy from time to time. Continued use of the app after changes constitutes acceptance of the updated policy.'
          },
          {
            title: '11. Contact',
            body: 'TrustTech Mobile · safesnap.app@gmail.com · https://safesnap-aa25e.web.app'
          },
        ].map((section, i) => (
          <div key={i} style={{ marginBottom: 36, paddingBottom: 36, borderBottom: i < 10 ? '0.5px solid rgba(10,10,15,0.08)' : 'none' }}>
            <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 10, color: 'var(--ink)' }}>{section.title}</h2>
            <p style={{ fontSize: 15, color: 'var(--muted)', lineHeight: 1.8 }}>{section.body}</p>
          </div>
        ))}
      </div>
      <footer><div className="footer-inner"><div className="footer-brand">SafeSnap</div><div className="footer-copy">TrustTech Mobile · safesnap.app@gmail.com</div></div></footer>
    </>
  );
}
